<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive :exclude="excludeCachedViews">
        <router-view :key="key" />
      </keep-alive> -->

      <keep-alive :include="cachedViews">
        <router-view v-if="isRouterAlive" :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  provide() {
		return {
			reload: this.reload
		}
	},
  data() {
		return {
			isRouterAlive: true
		}
	},
  computed: {
    excludeCachedViews() {
      return 'Shopping'
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  methods: {
		reload() {
			this.isRouterAlive = false
			this.$nextTick(() => {
          this.isRouterAlive = true
      })
		}
	}
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 2px);
  }

  .fixed-header + .app-main {
    padding-top: 87px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
